module.exports = __webpack_public_path__ + "img/bottom-list1.15b23fb9.png";